import React, { useContext, useState } from "react"
import Form from "../BookTour/Form"
import { SpaceProfileContext } from "../context"
import isEmail from "validator/lib/isEmail"
import { isValidPhone } from "../../PhoneNumber"
import ProgressDots from "../../ProgressDots"
import * as s from "./Step3.module.less"
import moment from "moment-timezone"
import UserImage from "../BookTour/UserImage"
import submitBookTour from "../../../utils/submitBookTour"

const Step3 = ({ space = {}, locationsUuid = "", apiData = {} }) => {
  const {
    commonData: { bookTourStep, calendar, contextTime, contextDate, location },
    actions: { setValue, setBookTourStep },
  } = useContext(SpaceProfileContext)

  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [phone, setPhone] = useState("")
  const [message, setMessage] = useState("")
  const [marketingEmails, setMarketingEmails] = useState(true)

  const [formSubmitted, setFormSubmitted] = useState(false)
  const [progress, setProgress] = useState(false)

  const handleSubmit = async () => {
    setProgress(true)

    const res = await submitBookTour({
      user: { name, phone, email, message },
      locationsUuid,
      space: apiData,
      contextDate,
      contextTime,
      calendar,
      marketingEmails,
    })

    setValue({ bookTourComplete: true })
    setProgress(false)
    setFormSubmitted(true)
  }

  if (formSubmitted) {
    return (
      <div className={s.user_data}>
        <UserImage space={space} />
        <h5>Confirmed</h5>
        <p className="title-sub">
          You are scheduled with {space.contact_name || apiData.contact_name}.
        </p>
        <ul className="tour-summary">
          <li>{calendar.duration} minute call</li>
          <li>
            {contextTime}, {moment(contextDate).format("dddd, MMMM DD, YYYY")}
          </li>
          {apiData.office_address && (
            <li>{apiData.office_address.short_address}</li>
          )}
        </ul>
      </div>
    )
  }

  return (
    <div>
      <Form
        step={bookTourStep}
        space={space}
        name={name}
        setName={setName}
        email={email}
        setEmail={setEmail}
        message={message}
        setMessage={setMessage}
        phone={phone}
        setPhone={setPhone}
        inline
        marketingEmails={marketingEmails}
        setMarketingEmails={setMarketingEmails}
      />

      <div className={s.submit_block}>
        <button
          className="btn btn-link px-0"
          onClick={() => setBookTourStep(2)}
        >
          Back
        </button>
        <button
          onClick={handleSubmit}
          className={`btn btn-primary submit_schedule_call ${
            progress ? "submitting" : ""
          }`}
          disabled={
            !name ||
            !email ||
            !isEmail(email) ||
            !isValidPhone(phone, true) ||
            progress
          }
        >
          <ProgressDots active={progress} />
          Schedule Call
        </button>
      </div>
    </div>
  )
}

export default Step3
